export default "__VITE_ASSET__554962ef__"